// TODO: could probably give this a better name and structure, but simply moving it
// into the new package for now to pass type checks for DD_LOGS
export function handleDatadogLogger(userUID?: string): void {
  const _window = window as any
  let uid = ''
  if (userUID) uid = userUID
  _window.DD_LOGS &&
    _window.DD_LOGS.onReady(() => {
      if (!_window.DD_LOGS?.setGlobalContextProperty) {
        _window.DD_LOGS?.logger.error('setGlobalContextProperty is undefined on window.DD_LOGS', {})
        return
      }
      _window.DD_LOGS?.setGlobalContextProperty('uid', uid)
    })
}
